var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-number" }, [
    _c("i", {
      staticClass: "iconfont  minus",
      class: _vm.selectIcon === true ? "icon-minus" : "icon-arrow-left",
      on: { click: _vm.minus }
    }),
    _vm._v(" "),
    _c("i", {
      staticClass: "iconfont  plus",
      class: _vm.selectIcon === true ? "icon-plus" : "icon-arrow-right",
      on: { click: _vm.plus }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "input" }, [
      _c("input", {
        attrs: { type: "text", autocomplete: "off", disabled: "" },
        domProps: { value: _vm.defaultValue },
        on: { blur: _vm.checkNumber }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b9a3b9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b9a3b9a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inputnumber.vue
// module id = null
// module chunks = 